// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PYuanOutlinedSvg from "@fishx/icons-svg/es/asn/PYuanOutlined";
import FishxIcon from '../components/FishxIcon';

var PYuanOutlined = function PYuanOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PYuanOutlinedSvg
  }));
};

PYuanOutlined.displayName = 'PYuanOutlined';
export default React.forwardRef(PYuanOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PYuanOutlined.js
// module id = 3744
// module chunks = 0